"use client";

import { ReactNode } from 'react';
import { LivingCardsProvider } from '@/context/livingCards';

interface LivingCardsRootProps {
  children: ReactNode;
}

export default function LivingCardsRoot({ children }: LivingCardsRootProps) {
  return (
    <LivingCardsProvider>
      {children}
    </LivingCardsProvider>
  );
}